import Lock from '../../src/legacy/Lock';
export default Lock;
